import { render, staticRenderFns } from "./smart-recap.vue?vue&type=template&id=624355dc&scoped=true&"
import script from "./smart-recap.vue?vue&type=script&lang=js&"
export * from "./smart-recap.vue?vue&type=script&lang=js&"
import style0 from "./smart-recap.vue?vue&type=style&index=0&id=624355dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624355dc",
  null
  
)

export default component.exports